import { ContentFragmentElements } from '../ReactCarousel'
import { Elements } from '../ReactTeaser'

export enum ListType {
  static = 'static',
  featuredCategory = 'featuredCategory',
  differentIcons = 'differentIcons',
  cfStandardList = 'cfStandardList',
  cfConditionalList = 'cfConditionalList',
  cfGroupedStaticList = 'cfGroupedStaticList',
  inversionList = 'inversionList',
  storeLocatorList = 'storeCategory'
}

export type ReactListItemsProps = {
  id?: string
  path?: string
  pageTitle?: string
  lastModified?: number
  description?: string
  title?: string
  link?: string
  openinnewtab?: string
  anchor?: string
  icon?: string
  iconAlt?: string
}

export interface ReactListProps {
  listFrom?: string
  storeText?: string
  id?: string
  icon?: string
  heading?: string
  isInEditor?: boolean
  dateFormatString?: string
  fixedListItems?: Array<ReactListItemsProps>
  linkItems?: boolean
  showDescription?: boolean
  showModificationDate?: boolean
  componentProperties?: object
  differentIconsList?: Array<ReactListItemsProps>
  altIcon?: string
  top?: boolean
  right?: boolean
  bottom?: boolean
  left?: boolean
  lob?: string
  cfListItems?: Array<any>
  ruleExpression?: string
  elements?: Elements | ContentFragmentElements
  tokenProperties?: string
  index?: any
  maxLength?: number
  hideMCP?: boolean
  groupedItems?: any
  items?: any
  hoveredStoreId?: string | null
  selectedStoreId?: string | null
  onStoreHover?: (storeId: string | null) => void
  onStoreSelect?: (storeId: string | null) => void
  hasSearched?: boolean
  noStoresMessage?: string
  noStoresSubheading?: string
}

export interface CategoryItemType {
  title?: string
  id?: string
  iconAlt?: string
  description?: string
  link?: string
  openinnewtab?: string
  asset?: string
  icon?: string
  anchor?: string
  useRte?: boolean
}

export interface GroupedItemType {
  title: string
  iconPath: string
  iconAltTxt: string
  bulletPoints: string[]
}
